import { render, staticRenderFns } from "./MealIngredientAdd.vue?vue&type=template&id=26bf3a88&"
import script from "./MealIngredientAdd.vue?vue&type=script&lang=js&"
export * from "./MealIngredientAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports